export const REPORT_PATHS = {
  INCOME_EXPENSES: '/reports/incomes-expences',
  CASH_FLOW: '/reports/cash-flow',
  MANAGER: '/reports/manager',
  JOB_NUMBER: '/reports/job-number',
  CUSTOMER_BALANCE_DEBITOR: '/reports/customer-balance/debitor',
  CUSTOMER_BALANCE_CREDITOR: '/reports/customer-balance/creditor',
  INVOICES: '/reports/invoices',
  TAX_TYPES: '/reports/tax-types',
  SALE_TYPES: '/reports/sale-types',
  MEASUREMENT: '/reports/measurement',
  CANCELLED: '/reports/cancelled',
  BANK_TRANSFER: '/reports/bank-transfer',
};

export const reports = (translation) => [
  {
    path: REPORT_PATHS.INCOME_EXPENSES,
    label: translation.report.IncomeAndExpences,
    image: 'report-incomes-expenses',
  },
  {
    path: REPORT_PATHS.CASH_FLOW,
    label: translation.report.CashFlow,
    image: 'report-cash-flow',
  },
  {
    path: REPORT_PATHS.MANAGER,
    label: translation.report.Manager,
    image: 'report-manager',
  },
  {
    path: REPORT_PATHS.JOB_NUMBER,
    label: translation.report.JobNumber,
    image: 'report-job-number',
  },
  {
    path: REPORT_PATHS.CUSTOMER_BALANCE_DEBITOR,
    label: translation.reports.CustomerBalanceDebitor,
    image: 'report-customer-balance-info',
  },
  {
    path: REPORT_PATHS.CUSTOMER_BALANCE_CREDITOR,
    label: translation.reports.CustomerBalanceCreditor,
    image: 'report-customer-balance-info',
  },
  {
    path: REPORT_PATHS.INVOICES,
    label: translation.report.Invoices,
    image: 'report-invoices',
  },
  {
    path: REPORT_PATHS.TAX_TYPES,
    label: translation.report.TaxType,
    image: 'report-tax-types',
  },
  {
    path: REPORT_PATHS.SALE_TYPES,
    label: translation.report.SaleType,
    image: 'report-sale-types',
  },
  {
    path: REPORT_PATHS.MEASUREMENT,
    label: translation.report.Measurement,
    image: 'report-measurement',
  },
  {
    path: REPORT_PATHS.CANCELLED,
    label: translation.report.CancelledInvoices,
    image: 'report-cancelled-invoices',
  },
  {
    path: REPORT_PATHS.BANK_TRANSFER,
    label: translation.report.BankTransfer,
    image: 'report-bank-transfer',
  },
];
